import { Component } from "@angular/core";

@Component({
  standalone: false,
  selector: "app-loading",
  templateUrl: "./loading.component.html",
})
export class LoadingComponent {}
